import React from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

export interface InscriptionStatusChipProps {
  status: string;
}

const COLORS: Record<string, { label: string; color: string; bg: string }> = {
  PENDENTE: { label: 'Pendente', color: '#f0ad4e', bg: 'rgba(240,173,78,0.2)' },
  CONFIRMADA: { label: 'Confirmada', color: '#28a745', bg: 'rgba(40,167,69,0.2)' },
  CANCELADA: { label: 'Cancelada', color: '#dc3545', bg: 'rgba(220,53,69,0.2)' },
  FILA_ESPERA: { label: 'Fila de Espera', color: '#17a2b8', bg: 'rgba(23,162,184,0.2)' },
};

const InscriptionStatusChip: React.FC<InscriptionStatusChipProps> = ({ status }) => {
  const cfg = COLORS[status] || { label: status, color: '#6c757d', bg: 'rgba(108,117,125,0.2)' };
  return (
    <Chip
      label={cfg.label}
      className='ps-2'
      sx={{
        backgroundColor: cfg.bg,
        color: cfg.color,
        fontWeight: 500,
        '& .MuiChip-icon': { marginLeft: 0, marginRight: 0.5 },
      }}
      icon={<Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: cfg.color }} />}
      size="small"
    />
  );
};

export default InscriptionStatusChip;

